<template>
    <div></div>
</template>

<script>
export default {
    data: () => ({}),
    created() {
        console.log(this.$route)
    }
}
</script>
